import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "katman 1",
  viewBox: "0 0 183.63 183.63"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "91.81",
      cy: "91.81",
      r: "87.8",
      style: {"fill":"#fcdd53","stroke":"#e42a2b","stroke-miterlimit":"1.07","stroke-width":"8.03px"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M150.91 112.41c-2.9 3.5-5.6 5.4-10.4 6.2h-53c-2.7-1.3-2.9-3.2 0-4.5h30c2.7 0 5.1-.8 7-3.2 8.8-11.8 19-23 26.8-35.9-3.5 3.2-5.6 5.1-10.7 5.9h-36.7c-3.7 0-6.7 1.3-9.1 4.5-7.2 9.4-14.7 18.5-21.9 27.8-19 22.7-32.1-27.3-6.4-19.3-3.5-4.5-7.2-8.8-10.7-13.4-2.7-2.7-6.7-2.9-9.4 0-16.1 20.3-16.3 51.7 17.1 54.6h71.2c5.2-7.7 10.9-15.2 16.2-22.7Zm-11-63.7c-2.4 1.9-4 2.7-7.8 2.7h-32.4c-3.2 0-7.2 1.3-9.4 4l-20.6 26.2 5.9 7.5 7.2-8.8c2.4-2.7 5.1-3.7 8.8-3.7h20.1c10.3 0 23.4-22 28.2-27.9Z",
      style: {"fill":"#478c3e"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "HY-logo"}) } }